module.exports = __webpack_public_path__ + "static/media/9DESA16.bd00f30a.jpg";